import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/sats_menubar_logo.webp")